(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/analyze/assets/author-profile.js') >= 0) return;  svs.modules.push('/components/sport/analyze/assets/author-profile.js');
"use strict";


const {
  useAuthorProfilePicture
} = svs.components.sportinfo.gameAnalysesRedux.hooks;
const {
  Checkbox
} = svs.ui.reactForm;
const {
  useSelector
} = ReactRedux;
const {
  selectAuthorProfile
} = svs.components.sportinfo.gameAnalysesRedux.selectors;
const {
  ReactButton,
  ReactIconButton,
  ReactIcon
} = svs.ui;
const {
  linkType
} = svs.component.analyze.constants;
const {
  VisibilityWrapper
} = svs.components.lbUi.visibilityWrapper;
const {
  useState
} = React;
const TARGET_PROFILE_IMAGE_SIZE = 44;
const AuthorProfile = _ref => {
  let {
    authorId,
    onToggle,
    selected
  } = _ref;
  const authorProfile = useSelector(state => selectAuthorProfile(state, authorId));
  const profileImage = useAuthorProfilePicture(authorProfile, TARGET_PROFILE_IMAGE_SIZE);
  const authorLinkUrl = authorProfile === null || authorProfile === void 0 ? void 0 : authorProfile.authorLinkUrl;
  const authorLinkType = authorProfile === null || authorProfile === void 0 ? void 0 : authorProfile.authorLinkType;
  const authorPresentation = authorProfile === null || authorProfile === void 0 ? void 0 : authorProfile.authorPresentation;
  const [shouldShowAuthorPresentation, setShouldShowAuthorPresentation] = useState(false);
  let target;
  let rel;
  if (authorLinkType === linkType.EXTERNAL) {
    target = '_blank';
    rel = 'nofollow';
  }
  return React.createElement("div", {
    className: "draw-analysis-author-container"
  }, React.createElement("label", {
    className: "draw-analysis-author"
  }, profileImage && React.createElement("img", {
    alt: "Profil av ".concat(authorProfile.authorLongName),
    src: profileImage,
    style: {
      width: TARGET_PROFILE_IMAGE_SIZE,
      height: TARGET_PROFILE_IMAGE_SIZE
    }
  }), React.createElement("span", {
    className: "draw-analysis-name"
  }, authorProfile.authorLongName), React.createElement("span", {
    className: "draw_analysis_author__checkbox"
  }, React.createElement(Checkbox, {
    checked: selected,
    onChange: onToggle
  }))), React.createElement(VisibilityWrapper, {
    className: "draw_analysis_author__presentation",
    isVisible: shouldShowAuthorPresentation
  }, React.createElement("span", null, authorPresentation)), authorLinkUrl && React.createElement(ReactButton, {
    className: "draw-analysis-author-link-button",
    href: authorLinkUrl,
    rel: rel,
    size: 300,
    target: target,
    transparent: true
  }, "Till ombudet"), authorPresentation && React.createElement(ReactIconButton, {
    className: "draw_analysis_author__presentation_btn",
    onClick: () => setShouldShowAuthorPresentation(!shouldShowAuthorPresentation)
  }, React.createElement(ReactIcon, {
    color: "fc-navy",
    icon: shouldShowAuthorPresentation ? 'menu-up' : 'menu-down',
    size: "100"
  })));
};
setGlobal('svs.component.analyze.AuthorProfile', AuthorProfile);

 })(window);